import fetch from 'isomorphic-fetch';
import Message from '@/components/CloudIView/components/message/index';
import store from '@/store/index';
import { paramsStringify } from './util';

const REQUEST_TIMEOUT = 120; // 请求超时时间：秒
let statusCode;
// 向服务器发送请求返回的状态
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    statusCode = response.status;
    return response;
  }
  if (response.status === 401 || response.status === 403) {
    // 验证不通过，重新登录
    // store.dispatch('user/logout');
    statusCode = response.status;
    return false;
  }
  // 请求错误
  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}
// 对返回的数据装换为json格式
function parseJSON(response) {
  return response.json();
}
// 对response 数据进行处理
function httpResponse(res) {
  if (res) {
    return res;
  }
  Message.error('网络错误，请刷新重试！');
  return false;
}
/**
 * Requests a URL, return a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 */
export default function defaultRequest(url, options = {}) {
  const { method = 'get', headers = {}, params = {}, body = {} } = options;
  const requestUrl = Object.keys(params).length
    ? `${process.env.VUE_APP_REQUEST_BASE_URL}${url}?${paramsStringify(params)}`
    : `${process.env.VUE_APP_REQUEST_BASE_URL}${url}`;
  let requestOptions = {};

  const authorization =
    store.state.user.access_token && url !== '/oauth2/oauth/token'
      ? {
          Authorization: `Bearer ${store.state.user.access_token}`,
        }
      : {};
  if (method.toUpperCase() === 'GET') {
    requestOptions = {
      method,
      headers: new Headers({
        tenant_id: encodeURIComponent(store.state.user.tenantId),
        lang_id: store.state.lang === 'cn' ? 1 : 2,
        ...authorization,
        ...headers,
      }),
    };
  } else {
    requestOptions = {
      method,
      headers: new Headers({
        tenant_id: encodeURIComponent(store.state.user.tenantId),
        lang_id: store.state.lang === 'cn' ? 1 : 2,
        ...authorization,
        ...headers,
      }),
      body,
    };
  }
  return Promise.race([
    fetch(requestUrl, { ...requestOptions, credentials: 'include' }),
    new Promise((resolve, reject) => {
      setTimeout(() => reject(new Error('request timeout')), REQUEST_TIMEOUT * 1000);
    }),
  ])
    .then(checkStatus)
    .then(parseJSON)
    .then(response => httpResponse(response))
    .catch(error => {
      console.error(error.response);
      if (statusCode === 500) {
        Message.error({
          content:
            store.state.lang === 'cn'
              ? '网络错误，请刷新重试！'
              : 'Network error, please refresh and retry!',
          duration: 5,
        });
        return false;
      }
      Message.error({
        content: '用户名或密码输入错误！',
        duration: 1,
      });
      return false;
    });
}
